"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSideMenuLayoutHeaderSection = exports.StyledSideMenuLayoutMenu = exports.StyledSideMenuLayout = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const StackView_1 = require("../../StackView");
exports.StyledSideMenuLayout = (0, styled_components_1.default)(StackView_1.StackView) `
    position: relative;
    overflow: hidden;
    flex: 1;
`;
exports.StyledSideMenuLayoutMenu = (0, styled_components_1.default)(StackView_1.StackView) `
    position: relative;
    overflow: hidden;
    flex-shrink: 0;
    ${({ hasSeparator, theme }) => hasSeparator && `border-right: 1px solid ${theme === null || theme === void 0 ? void 0 : theme.colorBorderMain};`}
`;
exports.StyledSideMenuLayoutHeaderSection = (0, styled_components_1.default)(StackView_1.StackView) `
    padding: ${({ theme }) => `0 ${theme === null || theme === void 0 ? void 0 : theme.spacing.m}`};
`;
//# sourceMappingURL=SideMenuLayout.styles.js.map